const init = () => {

    console.log('In')

}
export { init }